import type { FC } from 'react';
import { MdArrowUpward } from 'react-icons/md';
import { cn } from '@/lib/utils';

/** Material Design upward arrow for the composer send button. */
export const ComposerSendIcon: FC<{ className?: string }> = ({ className }) => (
  <MdArrowUpward
    className={cn('aui-composer-send-icon', className)}
    aria-hidden
  />
);
